// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B1x9","left":"styles_left__3smwU"};